const  projectsReact = [
    {
       proTitle: "React projects", 
       projectProps: [
            {
                title: "React fundamentals",
                img: "./img_projects/React/project1.png",
                desc: "All the main features of the ReactJS library.",
                long_desc: "This application allows you to observe the main tasks that can be performed via the ReactJS library while running on a web server.",
                topics: "Javascript, ES6, JSON",
                location_url: "./web_app/projects/reactJS/react-fundamentals/index.html",
                source_code: false
            },
            {
                title: "Rick Wiki",
                img: "./img_projects/React/project2.png",
                desc: "Manage a restAPI in order to create a small wiki.",
                long_desc: "The project allows you to create a simple application that provides information relating to the protagonists of the animated series Rick and Morty in a wiki.",
                topics: "React, Laravel, Javascript, ES6, JSON",
                location_url: "https://github.com/pippo-github/react-laravel-RickWikiRestAPI",
                source_code: true
            },
            // {
            //     title: "project React 3",
            //     img: "./img_projects/React/project3.png",
            //     desc: "SSSSSS All the main fea.",
            //     long_desc: "This application allows you to federate the main activities that can be carried out through the ReactJS library while they are running on a web server",
            //     topics: "Javascript, ES6, JSON",
            //     location_url: "./web_app/projects/php/savio_sito/index.php",
            //     source_code: true
      
            // },
            // {
            //     title: "project React 4",
            //     img: "./img_projects/React/2.png",
            //     desc: "All the main features of the React library.",
            //     long_desc: "This application allows you to federate the main activities that can be carried out through the ReactJS library while they are running on a web server",
            //     topics: "Javascript, ES6, JSON",
            //     location_url: "./web_app/projects/php/savio_sito/index.php",
            //     source_code: true      
            // }
        ]
    }
]

export {projectsReact}
